const state = () => ({  // ✅ 修复：使用函数返回 state
  copyContent: [],
  folderList: [],
  userInfo:{},
  routers:[],
});

const mutations = {
  SET_COPY_CONTENT: (state, copyContent) => {
    state.copyContent = copyContent;
  },
  SET_FOLDER_LIST: (state, list) => {
    state.folderList = list;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROUTERS: (state, list) => {
    state.routers = list;
  },
};

const actions = {
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo);
  },
  setCopyContent({ commit }, copyContent) {
    commit('SET_COPY_CONTENT', copyContent);
  },
  setFolderList({ commit }, list) {
    commit('SET_FOLDER_LIST', list);
  },
  setRouters({ commit }, list) {
    commit('SET_ROUTERS', list);
  },
};

export default {
  state,  // 现在 state 是一个函数，符合 Vuex 规范
  mutations,
  actions
};
